import moment from 'moment'

// Formatting helpers ported from apeiron-web (src/components/bridge/tabs/workoutSetsTab.js)

export const formatDate = (date) =>
  date ? moment(date).format('YYYY-MM-DD') : null

export const formatDateTime = (value) =>
  value ? moment(value).format('YYYY-MM-DD HH:mm') : null

export const statusLabel = (status) => {
  if (!status) return null
  if (status === 'completed') return 'On target'
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export const weightReps = (weight, reps, unit) => {
  const parts = []
  if (weight != null) parts.push(`${weight}${unit || ''}`)
  if (reps != null) parts.push(`${reps} reps`)
  return parts.length ? parts.join(' × ') : null
}

export const formatTime = (ms) => {
  if (ms == null) return null
  const totalSeconds = Math.round(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`
}

export const formatTempo = (tempo) => {
  if (!tempo || !Object.keys(tempo).length) return null
  try {
    return JSON.stringify(tempo)
  } catch (err) {
    return null
  }
}

export const flagsText = (record) => {
  const flags = record?.flags
  if (!flags || (Array.isArray(flags) && !flags.length)) return null
  if (Array.isArray(flags)) return flags.join(', ')
  return String(flags)
}
